import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountInformationComponent } from './account-information.component';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { DateTimestampFormatPipe } from 'src/app/pipes/date-timestamp-format.pipe';



@NgModule({
  declarations: [
    AccountInformationComponent,
  ],
  imports: [
    IonicModule,
    CommonModule,
    ComponentsModule,
    DateTimestampFormatPipe,
  ],
  exports:[
    AccountInformationComponent
  ]
})
export class AccountInformationModule { }
